import { AdminLayout } from "./AdminLayout";
import { useState, useEffect } from "react";
import { TrendingUp, Eye, MousePointerClick, MessageSquare } from "lucide-react";
import axios from "axios";
import { API } from "../../App";
import { toast } from "sonner";

const MockupDashboard = () => {
  const [kpis, setKpis] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchKpis();
  }, []);

  const fetchKpis = async () => {
    try {
      const response = await axios.get(`${API}/client-mockups/dashboard/kpis`, { withCredentials: true });
      setKpis(response.data);
    } catch (error) {
      toast.error('Failed to fetch dashboard data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title="Mockups Dashboard">
      <div className="space-y-6">
        <h2 className="text-xl font-bold">Mockups Overview</h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="card-dashboard">
            <div className="flex items-center gap-3 mb-2">
              <TrendingUp className="w-5 h-5 text-[#5F8FB8]" />
              <span className="text-sm text-[#8A8A8A]">Total Leads</span>
            </div>
            <div className="text-3xl font-bold">{kpis?.total_leads || 0}</div>
          </div>

          <div className="card-dashboard">
            <div className="flex items-center gap-3 mb-2">
              <TrendingUp className="w-5 h-5 text-[#5F8FB8]" />
              <span className="text-sm text-[#8A8A8A]">Mockup Requests</span>
            </div>
            <div className="text-3xl font-bold">{kpis?.total_mockup_requests || 0}</div>
          </div>

          <div className="card-dashboard">
            <div className="flex items-center gap-3 mb-2">
              <Eye className="w-5 h-5 text-[#5F8FB8]" />
              <span className="text-sm text-[#8A8A8A]">Builds Created</span>
            </div>
            <div className="text-3xl font-bold">{kpis?.total_builds || 0}</div>
          </div>

          <div className="card-dashboard">
            <div className="flex items-center gap-3 mb-2">
              <MessageSquare className="w-5 h-5 text-[#5F8FB8]" />
              <span className="text-sm text-[#8A8A8A]">Feedback Received</span>
            </div>
            <div className="text-3xl font-bold">{kpis?.feedback_count || 0}</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="card-dashboard">
            <div className="text-sm text-[#8A8A8A] mb-1">Mockups Sent</div>
            <div className="text-2xl font-bold">{kpis?.sent_count || 0}</div>
          </div>

          <div className="card-dashboard">
            <div className="text-sm text-[#8A8A8A] mb-1">Mockups Viewed</div>
            <div className="text-2xl font-bold">{kpis?.viewed_count || 0}</div>
          </div>

          <div className="card-dashboard">
            <div className="text-sm text-[#8A8A8A] mb-1">View Rate</div>
            <div className="text-2xl font-bold text-[#5F8FB8]">{kpis?.view_rate || '0%'}</div>
          </div>
        </div>

        <div className="card-dashboard">
          <h3 className="text-base font-bold mb-4">Status Breakdown</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            <div>
              <div className="text-[#8A8A8A]">Sent</div>
              <div className="text-xl font-bold">{kpis?.sent_count || 0}</div>
            </div>
            <div>
              <div className="text-[#8A8A8A]">Viewed</div>
              <div className="text-xl font-bold">{kpis?.viewed_count || 0}</div>
            </div>
            <div>
              <div className="text-[#8A8A8A]">Feedback</div>
              <div className="text-xl font-bold">{kpis?.feedback_count || 0}</div>
            </div>
            <div>
              <div className="text-[#8A8A8A]">Total Requests</div>
              <div className="text-xl font-bold">{kpis?.total_mockup_requests || 0}</div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default MockupDashboard;
